import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getModuleItems } from "../../../application/selectors/modules";
import { setIsShowModuleSideBar } from "../../../application/slices/ui";
import Dashboard from "../../components/dashboard";
import BreadcrumbsComponent from "../../components/shared/breadcrumbs";

const SettingPage = () => {
  const dispatch = useDispatch();

  const [module, setModule] = useState({ name: "تنظیمات", children: [] });
  const modules = useSelector(getModuleItems);

  useEffect(() => {
    if (modules && Array.isArray(modules)) {
      const item = modules.find((x) => x.id === "setting");
      if (item) {
        setModule(item);
      }
    }
  }, [modules]);

  const onClickModules = (module) => {
    console.log("clicked module", module);
    dispatch(setIsShowModuleSideBar(true));
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={12}>
        <BreadcrumbsComponent />
      </Grid>

      <Grid item xs={12} md={12}>
        <Dashboard
          // modules={module.children}
          cartTitle={module.name}
          // onClickModules={onClickModules}
        />
      </Grid>
    </Grid>
  );
};

export default SettingPage;
